import type { Nullable } from './common'
import type { Workspace } from './workpace'

export enum Role {
  ADMIN = 'admin',
  HOST = 'host',
}

export enum UserPermission {
  ADMIN,
  STAFF,
  HOST,
  BOOKING_USER,
}

export type UserId = number

export type User = {
  id: UserId
  role: Role
  permission: UserPermission
  firstName: string
  lastName: string
  fullName: string
  avatar?: string
  workspace: Nullable<Workspace>
}
